import Reac, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Collapse,
  Grid,
  TextField,
  InputAdornment,
  Dialog,
  DialogContent,
  Button,
  Snackbar,
  Alert,
  Divider
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import GooglePlaces from '../GooglePlaces';

import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import Iconify from '../Iconify';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import dayjs from 'dayjs';
import LocationPickerMap from '../LocationPickerMap';
import ProjectManagerDropdown from '../ProjectManagerDropdown';
import { api } from 'src/Api';
import JobGroupEditAdd from '../JobGroupEditAdd';
import { NumericFormat } from 'react-number-format';

const PostDetailsForm = ({
  postOpen,
  formData,
  errors,
  handlePostOpen,
  handleChangevalue,
  onResultAddress,
  MAX_COMMENT_LENGTH,
  onResultAddressDestination,
  disabled,
  handleDateChange,
  detail_id,
  setFormData
}) => {
  const [mapOpen, setMapOpen] = useState(false);
  const [locationType, setLocationType] = useState('');
  const [contactList, setContactList] = useState([]);
  const [selectedContact, setSelectedContact] = useState([]);
  const [contactAddModal, setContactAddModal] = useState({ open: false, mode: 'add', value: '' });
  const [saveLoading, setSaveLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [spotRateData, setSpotRateData] = useState({});
  const [calculationData, setCalculationData] = useState({});
  const [calRateInput, setCalInputRate] = useState(0);

  useEffect(() => {
    getContact();
    getMarketRate();
  }, []);

  useEffect(() => {
    if (spotRateData) {
      const perDayRate = spotRateData?.average_rate * formData.distance;
      const perDayRateMin = spotRateData?.min_rate * formData.distance;
      const perDayRateMax = spotRateData?.max_rate * formData.distance;
      setCalculationData({
        perDayRate: perDayRate,
        perDayRateMin: perDayRateMin,
        perDayRateMax: perDayRateMax
      });
    }
  }, [formData.distance, spotRateData]);

  useEffect(() => {
    if (formData?.rate) {
      const calInputRate = formData?.rate / formData?.distance;
      setCalInputRate(calInputRate);
    } else {
      setCalInputRate(0);
    }
  }, [formData?.rate]);

  const handleLocationIconClick = (type) => {
    setLocationType(type);
    setMapOpen(true);
  };

  const handleSelectLocation = (type, locationData) => {
    setFormData((prev) => ({
      ...prev,
      [type]: locationData
    }));
    setMapOpen(false);
  };

  function getContact() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_contact_list, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setContactList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  function handleJobGroupSave({ id, name }) {
    setSaveLoading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    name && formData.append('contact_no', name);
    id && formData.append('id', id);

    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: myHeaders,
      body: formData
    };

    fetch(api.add_edit_contact_list, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          getContact();
          if (contactAddModal.mode !== 'add') {
            setSelectedContact([id]);
          }
          setContactAddModal({ ...contactAddModal, open: false });
        } else {
          setSnackbarMessage(result.errors);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setSnackbarMessage(error?.errors);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        console.log('error', error);
      })
      .finally(() => {
        setSaveLoading(false);
      });
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  function getMarketRate() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    // const queryParams = new URLSearchParams();
    // queryParams.append('miles', formData.distance);

    fetch(api.get_truck_marketrates, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setSpotRateData(result.spot_rate);
        } else {
          setSpotRateData({});
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  }

  return (
    <Box
      sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2 }}
      style={{
        borderRadius: 6,
        borderBottomLeftRadius: postOpen ? 6 : 6,
        borderBottomRightRadius: postOpen ? 6 : 6
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: '#eee',
          height: 40,
          padding: '0px 15px 0px 15px'
        }}
        style={{
          borderRadius: 6,
          borderBottomLeftRadius: postOpen ? 0 : 6,
          borderBottomRightRadius: postOpen ? 0 : 6
        }}
        onClick={handlePostOpen}
      >
        <Typography
          variant="overline"
          sx={{ flex: 1, fontSize: 14, textTransform: 'capitalize', color: '#000' }}
        >
          Post Details
        </Typography>
        {postOpen ? <ExpandLess sx={{ color: '#000' }} /> : <ExpandMore sx={{ color: '#000' }} />}
      </Box>

      <Box>
        <Collapse in={postOpen}>
          <Box
            sx={{ flexWrap: 'nowrap', padding: '0px 15px 0px 15px' }}
            style={{
              borderBottomLeftRadius: postOpen ? 6 : 0,
              borderBottomRightRadius: postOpen ? 6 : 0
            }}
          >
            <Typography
              sx={{
                marginTop: 2,
                borderBottom: '2px solid #eee',
                paddingBottom: 0.5,
                marginBottom: 2,
                color: '#000000',
                fontSize: 13,
                fontWeight: 'bold',
                textTransform: 'capitalize'
              }}
            >
              Location
            </Typography>

            <Grid container spacing={1} mb={2}>
              <Grid item spacing={2} xs={10.7} sm={11} md={6}>
                <GooglePlaces
                  width={'100%'}
                  onResult={onResultAddress}
                  placeholder={`Origin (City/ST/ZIP) -`}
                  // regions={true}
                  address={formData?.origin?.address}
                  error={Boolean(errors.origin)}
                  helperText={errors.origin}
                  disabled={disabled}
                />
                {!disabled && (
                  <div
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 5
                    }}
                    onClick={() => handleLocationIconClick('origin')}
                  >
                    <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                    <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>
                      Set Location on map
                    </p>
                  </div>
                )}
              </Grid>
              {/* {!disabled && (
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                    // width: '40px'
                  }}
                >
                  <div
                    style={{
                      cursor: 'pointer',
                      border: '1px solid #D8DDE1',
                      width: 50,
                      height: 50,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: 7
                    }}
                    onClick={() => handleLocationIconClick('origin')}
                  >
                    <Iconify icon="mdi:location" style={{ color: '#000', fontSize: 25 }} />
                  </div>
                </Grid>
              )} */}
              <Grid item spacing={2} xs={10.7} sm={11} md={6}>
                <GooglePlaces
                  disabled={disabled}
                  width={'100%'}
                  onResult={onResultAddressDestination}
                  placeholder={'Destination (City/ST/ZIP) -'}
                  // regions={true}
                  address={formData?.destination?.address}
                  error={Boolean(errors.destination)}
                  helperText={errors.destination}
                />
                {!disabled && (
                  <div
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 5
                    }}
                    onClick={() => handleLocationIconClick('destination')}
                  >
                    <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                    <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>
                      Set Location on map
                    </p>
                  </div>
                )}
              </Grid>
              {/* {!disabled && (
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      cursor: 'pointer',
                      border: '1px solid #D8DDE1',
                      width: 50,
                      height: 50,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: 7
                    }}
                    onClick={() => handleLocationIconClick('destination')}
                  >
                    <Iconify icon="mdi:location" style={{ color: '#000', fontSize: 25 }} />
                  </div>
                </Grid>
              )} */}
            </Grid>

            <Grid container spacing={2} xs={13}>
              <Grid item spacing={2} xs={6}>
                <Grid item mb={2} xs={12}>
                  <TextField
                    disabled={disabled}
                    label="Origin/City"
                    type="text"
                    value={formData?.origin?.city || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        origin: {
                          ...prev.origin,
                          city: e.target.value // ✅ yahan update hoga
                        }
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                        e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                      }
                    }}
                  />
                </Grid>
                <Grid item container spacing={2} mb={2} xs={12}>
                  <Grid item mb={2} xs={6}>
                    <TextField
                      disabled={disabled}
                      label="Origin/State"
                      type="text"
                      value={formData?.origin?.state || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          origin: {
                            ...prev.origin,
                            state: e.target.value // ✅ yahan update hoga
                          }
                        }))
                      }
                      fullWidth
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                  <Grid item mb={2} xs={6}>
                    <TextField
                      disabled={disabled}
                      label="Origin/Zip Code"
                      type="text"
                      value={formData?.origin?.zip_code || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          origin: {
                            ...prev.origin,
                            zip_code: e.target.value // ✅ yahan update hoga
                          }
                        }))
                      }
                      fullWidth
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item spacing={2} xs={6}>
                <Grid item mb={2} xs={12}>
                  <TextField
                    disabled={disabled}
                    label="Destination/City"
                    type="text"
                    value={formData?.destination?.city || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        destination: {
                          ...prev.destination,
                          city: e.target.value // ✅ yahan update hoga
                        }
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                        e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                      }
                    }}
                  />
                </Grid>
                <Grid item container spacing={2} mb={2} xs={12}>
                  <Grid item mb={2} xs={6}>
                    <TextField
                      disabled={disabled}
                      label="Destination/State"
                      type="text"
                      value={formData?.destination?.state || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          destination: {
                            ...prev.destination,
                            state: e.target.value // ✅ yahan update hoga
                          }
                        }))
                      }
                      fullWidth
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                  <Grid item mb={2} xs={6}>
                    <TextField
                      disabled={disabled}
                      label="Destination/Zip Code"
                      type="text"
                      value={formData?.destination?.zip_code || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          destination: {
                            ...prev.destination,
                            zip_code: e.target.value // ✅ yahan update hoga
                          }
                        }))
                      }
                      fullWidth
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {formData.distance && (
              <Typography sx={{ fontSize: 28, color: 'gray', fontWeight: '700' }}>
                {formData.distance} km
              </Typography>
            )}

            <Typography
              sx={{
                marginTop: 2,
                borderBottom: '2px solid #eee',
                paddingBottom: 0.5,
                marginBottom: 2,
                color: '#000000',
                fontSize: 13,
                fontWeight: 'bold'
                // textTransform: 'capitalize'
              }}
            >
              {'Available Date(s)'}
            </Typography>

            <Grid container spacing={2} mb={2}>
              <Grid item spacing={2} xs={12} sm={6}>
                <Typography
                  sx={{
                    fontSize: 13,
                    lineHeight: 1.3,
                    color: '#b4b4b4',
                    mb: 1
                  }}
                >
                  {'Specify your avialable date or date range'}
                </Typography>
                <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <Grid item>
                        {disabled === undefined && detail_id === undefined ? (
                          <DatePicker
                            minDate={dayjs()}
                            className="custom-textfield"
                            label="Pickup Earliest"
                            name="dateEarliest"
                            value={formData?.dateEarliest ? dayjs(formData?.dateEarliest) : null}
                            onChange={(newValue) => handleDateChange('dateEarliest', newValue)}
                            error={Boolean(errors.dateEarliest)}
                            helperText={errors.dateEarliest}
                          />
                        ) : (
                          <DatePicker
                            className="custom-textfield"
                            disabled={true}
                            label="Pickup Earliest"
                            value={dayjs(formData?.dateEarliest)}
                          />
                        )}

                        {errors.dateEarliest && (
                          <p
                            style={{ fontSize: 12, color: '#FF4842', marginLeft: 18, marginTop: 3 }}
                          >
                            {errors.dateEarliest}
                          </p>
                        )}
                      </Grid>
                      <Grid item>
                        {disabled === undefined && detail_id === undefined ? (
                          <DatePicker
                            minDate={dayjs()}
                            className="custom-textfield"
                            label="Pickup Latest"
                            name="dateLatest"
                            value={formData?.dateLatest ? dayjs(formData?.dateLatest) : null}
                            onChange={(newValue) => handleDateChange('dateLatest', newValue)}
                            error={Boolean(errors.dateLatest)}
                            helperText={errors.dateLatest || ''}
                          />
                        ) : (
                          <DatePicker
                            className="custom-textfield"
                            disabled={true}
                            label="Pickup Latest"
                            value={dayjs(formData?.dateLatest)}
                          />
                        )}
                        {errors.dateLatest && (
                          <p
                            style={{ fontSize: 12, color: '#FF4842', marginLeft: 18, marginTop: 3 }}
                          >
                            {errors.dateLatest}
                          </p>
                        )}
                      </Grid>
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            <Typography
              sx={{
                marginTop: 2,
                borderBottom: '2px solid #eee',
                paddingBottom: 0.5,
                marginBottom: 2,
                color: '#000000',
                fontSize: 13,
                fontWeight: 'bold',
                textTransform: 'capitalize'
              }}
            >
              {'Set Minimum Rate (Optional)'}
            </Typography>

            <Grid container spacing={2} mb={2}>
              <Grid item xs={5.5}>
                <Typography
                  sx={{
                    fontSize: 13,
                    paddingBottom: 2,
                    lineHeight: 1.3,
                    maxWidth: 350,
                    color: '#b4b4b4'
                  }}
                >
                  {
                    'The minimum rate per mile you are willing to accept as a starting point for negotiation ($USD)'
                  }
                </Typography>
                <TextField
                  disabled={disabled}
                  fullWidth
                  label="Rate"
                  name="rate"
                  value={formData?.rate}
                  onChange={handleChangevalue}
                  error={Boolean(errors.rate)}
                  helperText={errors.rate}
                  type="number"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment sx={{ fontSize: 12 }} position="start">
                        $
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment sx={{ fontSize: 12 }} position="start">
                        / Mile
                      </InputAdornment>
                    ),
                    inputProps: {
                      style: { minWidth: '100px', textAlign: 'left', paddingLeft: '0px' } // minimum width and left alignment
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                  className="custom-textfield"
                />
              </Grid>
              <Grid item xs={6.5} ml={0}>
                {/* <Typography
                  sx={{
                    paddingBottom: 0.5,
                    color: '#000000',
                    fontSize: 14,
                    fontWeight: 'bold',
                    textTransform: 'capitalize'
                  }}
                >
                  {'Market Rates'}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    marginLeft: 2,
                    marginTop: 3
                  }}
                >
                  <Iconify sx={{ fontSize: 37, marginRight: 1 }} icon={'system-uicons:box-open'} />
                  <Typography
                    sx={{
                      fontSize: 13,
                      paddingBottom: 0.5,
                      marginTop: 0.8,
                      lineHeight: 1.3,
                      maxWidth: 272,
                      color: '#b4b4b4'
                    }}
                  >
                    {
                      'Select an origin, destination (city, state,zip), and equipment type to view rates'
                    }
                  </Typography>
                </Box> */}
                <Box sx={{ flex: 1, marginLeft: 2 }}>
                  <Typography sx={{ fontSize: 14, marginTop: 2, marginBottom: 2 }}>
                    Market Rates
                  </Typography>

                  <Box style={{ border: '2px solid #F0F0F9' }}>
                    <Box
                      style={{
                        backgroundColor: '#F0F0F9',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '2px 10px 2px 10px'
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          fontWeight: 'bold',
                          letterSpacing: 1.5
                        }}
                      >
                        SPOT RATE
                      </Typography>
                      {formData?.origin && formData?.destination && (
                        <Typography
                          style={{
                            fontSize: 10,
                            color: '#000000'
                          }}
                        >
                          {formData?.origin.city} - {formData?.destination.city}
                        </Typography>
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: 'end',
                        marginTop: 1,
                        marginRight: 1,
                        color: '#000000'
                      }}
                    >
                      {formData?.distance || 0} km | 30d average
                    </Typography>

                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '5px 10px 0px 10px'
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#999999', minWidth: '20%' }}>
                        Average rate :
                      </Typography>
                      <Typography
                        sx={{ fontSize: 14, textAlign: 'right', flex: 1, color: '#000000' }}
                      >
                        {spotRateData?.average_rate ? `$${spotRateData?.average_rate}/Km` : '0 /km'}
                      </Typography>
                    </Box>

                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0px 10px 0px 10px'
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#999999', minWidth: '20%' }}>
                        Average rate range :
                      </Typography>
                      <Typography
                        sx={{ fontSize: 12, color: '#000000', textAlign: 'right', flex: 1 }}
                      >
                        {calculationData?.perDayRateMin || calculationData?.perDayRateMax
                          ? `$${calculationData?.perDayRateMin?.toFixed(
                              2
                            )}/Km - $${calculationData?.perDayRateMax?.toFixed(2)}/Km`
                          : '0 - 0'}
                      </Typography>
                    </Box>

                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0px 10px 0px 10px'
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#999999' }}>
                        Average amount range :
                      </Typography>
                      <Typography
                        sx={{ fontSize: 12, color: '#000000', textAlign: 'right', flex: 1 }}
                      >
                        {spotRateData?.min_rate || spotRateData?.max_rate
                          ? `${spotRateData?.min_rate?.toFixed(
                              2
                            )} - ${spotRateData?.max_rate?.toFixed(2)}`
                          : '0 - 0 /km'}
                      </Typography>
                    </Box>

                    <Box
                      style={{
                        backgroundColor: '#F0F0F9',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '2px 10px 2px 10px',
                        marginTop: 25
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          fontWeight: 'bold'
                        }}
                      >
                        FOR TRUCK RATE
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        marginBottom: 3
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          textAlign: 'end',
                          marginTop: 1,
                          marginRight: 1,
                          color: '#000000',
                          marginBottom: 1
                        }}
                      >
                        {formData?.distance || '0'} km
                      </Typography>

                      <Box
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '0px 10px 0px 10px'
                        }}
                      >
                        <Typography sx={{ fontSize: 12, color: '#999999' }}>Rate :</Typography>
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: '#000000'
                          }}
                        >
                          <NumericFormat
                            value={calRateInput ? parseFloat(calRateInput).toFixed(2) : '0'}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            style={{ color: '#000' }}
                          />
                        </Typography>
                      </Box>
                      <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                      <Box
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '0px 10px 0px 10px'
                        }}
                      >
                        <Typography sx={{ fontSize: 12, color: '#999999' }}>
                          Total Amount :
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: '#000000',
                            textAlign: 'right',
                            flex: 1,
                            fontWeight: 'bold'
                          }}
                        >
                          ${formData?.rate ? formData?.rate : '0'}
                        </Typography>
                      </Box>
                    </Box>
                    {/* ) : (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                          marginLeft: 5,
                          marginTop: 3,
                          marginBottom: 3
                        }}
                      >
                        <>
                          <Iconify
                            sx={{ fontSize: 35, marginRight: 1 }}
                            icon={'system-uicons:box-open'}
                          />
                          <Typography
                            sx={{
                              fontSize: 12,
                              paddingBottom: 0.5,
                              marginTop: 0.8,
                              lineHeight: 1.3,
                              maxWidth: 252,
                              color: '#b4b4b4'
                            }}
                          >
                            Contract Rates are not avialable for this subscription
                          </Typography>
                        </>
                      </Box>
                    )} */}
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12} mb={2}>
              <Grid item xs={12} md={12}>
                <ProjectManagerDropdown
                  disabled={disabled}
                  label="Contact"
                  name="contact"
                  // value={selectedContact} // Always an array of IDs
                  // onChange={(e) => setSelectedContact(e.target.value)}
                  value={formData?.contact}
                  onChange={(e) => {
                    handleChangevalue(e);
                    setSelectedContact(e.target.value);
                  }}
                  showNameTag={false}
                  options={contactList.map((val) => ({
                    value: val?.id,
                    name: val?.contact_no
                  }))}
                  error={Boolean(errors.contact)}
                  helperText={errors.contact}
                  placeholder=""
                  labelFontMedium
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  mt: { xs: 0, md: 2 },
                  mb: { xs: 1 },
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: 30,
                    width: 60,
                    borderRadius: 5,
                    letterSpacing: 0.5,
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                    transition: 'width 0.3s ease',
                    marginRight: 10
                  }}
                  height={30}
                  fontSize={12}
                  onClick={() => setContactAddModal({ open: true, mode: 'add', value: '' })}
                >
                  Add
                </Button>

                <Button
                  variant="contained"
                  disabled={selectedContact?.length === 1 ? false : true}
                  style={{
                    height: 30,
                    width: 60,
                    borderRadius: 5,
                    letterSpacing: 0.5,
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                    transition: 'width 0.3s ease'
                  }}
                  height={30}
                  fontSize={12}
                  onClick={() => {
                    const selectedId = selectedContact[0];
                    const selectedGroup = contactList.find((g) => g.id === selectedId);
                    setContactAddModal({
                      open: true,
                      mode: 'edit',
                      value: {
                        id: selectedGroup?.id,
                        name: selectedGroup?.contact_no || ''
                      }
                    });
                  }}
                >
                  Edit
                </Button>
              </Grid>
            </Grid>

            <Typography
              sx={{
                marginTop: 2,
                borderBottom: '2px solid #eee',
                paddingBottom: 0.5,
                marginBottom: 2,
                color: '#000000',
                fontSize: 13,
                fontWeight: 'bold',
                textTransform: 'capitalize'
              }}
            >
              Comments
            </Typography>

            <Grid container spacing={2} mb={2}>
              <Grid item xs={5} md={6}>
                <TextField
                  disabled={disabled}
                  label="Comment"
                  name="comment"
                  multiline
                  rows={6}
                  fullWidth
                  value={formData?.comment}
                  onChange={handleChangevalue}
                  error={Boolean(errors.comment)}
                  helperText={
                    errors.comment ||
                    `${formData?.comment?.length} / ${MAX_COMMENT_LENGTH} characters`
                  }
                  className="custom-textfield"
                  InputProps={{
                    shrink: true,
                    style: {
                      fontSize: 14,
                      padding: '10px 0px', // Add padding to input field
                      marginLeft: 3
                    }
                  }}
                />
              </Grid>
              <Grid item xs={5} md={6}>
                <TextField
                  disabled={disabled}
                  label="Reference ID"
                  name="referenceId"
                  type="number"
                  fullWidth
                  value={formData?.referenceId}
                  onChange={handleChangevalue}
                  error={Boolean(errors.referenceId)}
                  helperText={errors.referenceId}
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Collapse>
      </Box>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* JOB GROUP ADD/EDIT MODAL */}
      <JobGroupEditAdd
        open={contactAddModal.open}
        mode={contactAddModal.mode}
        initialValue={contactAddModal.value}
        onSave={handleJobGroupSave}
        onClose={() => setContactAddModal({ ...contactAddModal, open: false })}
        // onDelete={...}
        saveLoading={saveLoading}
      />

      {/* Map Dialog */}
      <Dialog open={mapOpen} onClose={() => setMapOpen(false)} maxWidth="md" fullWidth>
        <DialogContent>
          <LocationPickerMap
            open={mapOpen}
            onClose={() => setMapOpen(false)}
            locationType={locationType}
            selectedLocationFromForm={formData[locationType]}
            onSelectLocation={handleSelectLocation}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default PostDetailsForm;
